import type { PrinterConfig } from '@/utils/qzTray/qzTrayClient'

export { printHtml } from '@/utils/qzTray/qzTrayClient'

/** 라벨(반품처리)·바코드 재발행 두 규격(1.0 `RGRTemplate.js` 고정값, 8.1-9). */
export const LABEL_PRINTER_CONFIG: PrinterConfig = { printerName: 'BIXOLON SLP-DL410', width: 3.5, height: 4.5, units: 'in' }
export const BARCODE_PRINTER_CONFIG: PrinterConfig = { printerName: 'BARCODE', width: 3, height: 4.5, units: 'in' }
